
<template>
  <div>
    <div class="container-fluid" style="margin-top: 20px">
      <b-table
        striped
        hover
        :busy="isLoading"
        :items="newsData"
        :fields="fields"
        small
        fixed
        caption-top
        outlined
        @row-dblclicked="toggleDetails"
        :per-page="5"
        :current-page="currentPage"
      >
        <template v-slot:cell(actions)="data">
          <b-button
            variant="primary"
            size="sm"
            @click="editNews(data.item)"
            v-b-modal.editNews
          >
            <fa icon="edit" size="sm" />Edit
          </b-button>
          <b-button
            variant="danger"
            size="sm"
            @click="deleteNews(data.item)"
            v-b-modal.deleteNews
          >
            <fa icon="trash" size="sm" />
          </b-button>
        </template>
        <template v-slot:row-details>
          <p>restantes dados</p>
          <!-- <b-col>
            <b-row>
              <b-col>
                <p>Title</p>
                <b-form-textarea id="textarea" v-model="row.item.c_u_Title" rows="3" max-rows="6"></b-form-textarea>
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row>
              <b-col>
                <p>Resume</p>
                <b-form-textarea id="textarea" v-model="row.item.c_u_Resume" rows="3" max-rows="6"></b-form-textarea>
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row>
              <b-col>
                <p>Image</p>
                <b-container fluid class="p-4 bg-white">
                </b-container>
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row>
              <b-col>
                <p>Content</p>
                <b-form-textarea id="textarea" v-model="row.item.c_u_Content" rows="3" max-rows="6"></b-form-textarea>
              </b-col>
            </b-row>
          </b-col> -->

          <!-- <vue-editor v-model="row.item.c_u_Title"></vue-editor> -->
        </template>
      </b-table>
    </div>
    <div class="mt-3">
      <b-pagination
        :total-rows="totalItems"
        :per-page="5"
        align="center"
        v-model="currentPage"
      ></b-pagination>
    </div>
    <!-- modal for the CRUD -->
    <deleteNews :newsExtracted="newsExtracted" @ok="getNews()"></deleteNews>
    <editNews :newsEditId="newsEditId" @ok="getNews()"></editNews>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { mapGetters } from "vuex";
import deleteNews from "../News/NewsDelete";
import editNews from "../News/NewsEdit";

export default {
  data() {
    return {
      newsData: [],
      endpoint: "News",
      totalItems: 0,
      newsExtracted: null,
      newsEditId: null,
      currentPage: 1,
      fields: [
        {
          key: "c_u_IdentificationMethod",
          label: "Extration from",
        },
        {
          key: "c_u_Status",
          label: "Status",
          formatter: (value, key, item) => {
            if (value == 1) {
              return (value = "News saved but not extracted");
            }
            if (value == 2) {
              return (value = "News saved and extracted");
            }
            if (value == 3) {
              return (value = "News extraction failure");
            }
          },
        },
        {
          key: "c_u_ProcessedDate",
          label: "Processed",
        },
        {
          key: "c_u_Source",
          label: "Source",
          formatter: (value, key, item) => {
            return item.sources.c_u_ReferenceSource;
          },
        },
        {
          key: "c_u_Title",
          label: "Title",
        },
        {
          key: "actions",
          label: "Actions",
        },
      ],
    };
  },
  components: {
    VueEditor,
    deleteNews,
    editNews,
  },
  computed: {
    ...mapGetters({
      isLoading: "api/isLoading",
    }),
  },

  methods: {
    async getNews() {
      this.$api.data.endpoint = this.endpoint;
      this.newsData = await this.$api.data.find();
      this.totalItems = this.newsData.length;
      this.$forceUpdate();
    },
    deleteNews(item) {
      this.newsExtracted = item.c_id;
      this.$forceUpdate();
    },
    editNews(item) {
      this.newsEditId = item.c_id;
      this.$forceUpdate();
    },
    toggleDetails(data) {
      this.$set(data, "_showDetails", data._showDetails ? false : true);
    },
  },
  async mounted() {
    this.getNews();
    this.$forceUpdate();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/News/NewsMain.vue